import React, { useState, forwardRef } from "react";
import PropTypes from "prop-types";
import { Box, Text } from "@chakra-ui/react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useColorModeValue } from "../../ui/color-mode";
import { darkMode, lightMode } from "../../../theme/config";

const ContactBox = forwardRef(({
  label = null,
  invalid = false,
  errorText = "",
  register = null,
  value = "",
  onChange = () => { },
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  const borderColor = useColorModeValue(
    lightMode.inputBoxBorderColor,
    darkMode.inputBoxBorderColor
  );
  const focusBorderColor = useColorModeValue(
    lightMode.inputFocusBorderColor,
    darkMode.inputFocusBorderColor
  );
  const textColor = useColorModeValue(
    lightMode.inputTextColor,
    darkMode.inputTextColor
  );
  const errorBorderColor = useColorModeValue(
    lightMode.inputErrorBorderColor,
    darkMode.inputErrorBorderColor
  );

  const handleChange = (newValue) => {
    // call provided onChange if any
    onChange?.(newValue);
    // forward to react-hook-form if register prop present
    register?.onChange?.({
      target: {
        name: register.name,
        value: newValue,
      },
    });
  };

  return (
    <Box>
      {label && (
        <Box
          as="label"
          display="block"
          fontWeight="semibold"
          pb={0.5}
          color={textColor}
        >
          {label}
        </Box>
      )}

      <Box
        border={isFocused ? "1.6px solid" : "1px solid"}
        borderColor={
          errorText
            ? errorBorderColor
            : isFocused
              ? focusBorderColor
              : borderColor
        }
        borderRadius="2px"
      >
        <PhoneInput
          international
          defaultCountry="IN"
          value={value}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            width: "100%",
            padding: "0.45rem",
            color: textColor,
          }}
          className="input-phone-number"
          ref={ref}
        />
      </Box>

      {invalid && errorText && (
        <Text
          color={errorBorderColor}
          fontWeight="semibold"
          fontSize="small"
          mt={1}
        >
          {errorText}
        </Text>
      )}
    </Box>
  );
});

ContactBox.displayName = "ContactBox";

ContactBox.propTypes = {
  label: PropTypes.node,
  invalid: PropTypes.bool,
  errorText: PropTypes.string,
  register: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }),
  value: PropTypes.string,
  onChange: PropTypes.func,
};

ContactBox.defaultProps = {
  label: null,
  invalid: false,
  errorText: "",
  register: null,
  value: "",
  onChange: () => { },
};

export default ContactBox;
